module.exports = __webpack_public_path__ + "img/video-01.11a9fed5.png";